import { orderBy as _orderBy } from 'lodash';
import { parseISO } from 'date-fns';

export const orderItemsByUpdatedAt = (items) =>
  _orderBy(items, [(item) => parseISO(item.updatedAt)], ['desc']);
